/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useContext } from 'react';
import { ExperienceTrackerContext } from '@atlassian/experience-tracker/component/ExperienceTrackerContext';
import type { ExperienceTrackerAPI } from '@atlassian/experience-tracker/ExperienceTracker';

export const useExperienceContext = (): ExperienceTrackerAPI => {
	const context = useContext(ExperienceTrackerContext);
	return context;
};
